import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL ?? 'http://127.0.0.1:54321';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY ?? '';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

/**
 * Set the auth session for RLS-filtered Realtime subscriptions.
 * Call this after login (com refresh token) E no boot (só access token).
 *
 * DSH-01 (2026-06-12): o boot do app não tem refresh token, e
 * `auth.setSession({ refresh_token: '' })` FALHA com "Auth session missing!"
 * — o Realtime ficava com o token anon, o canal assinava "com sucesso" e o
 * RLS filtrava TODOS os eventos em silêncio (zero pushes até o próximo
 * login). `realtime.setAuth(jwt)` autoriza os joins diretamente, sem
 * depender da sessão.
 */
export function setSupabaseAuth(accessToken: string, refreshToken?: string) {
  supabase.realtime.setAuth(accessToken);
  if (refreshToken) {
    void supabase.auth.setSession({
      access_token: accessToken,
      refresh_token: refreshToken,
    });
  }
}
